/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs */

const en_forms_teams_settings_phone_is_user_allowed_to_access_camera_settings = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera Settings`)
};

const de_forms_teams_settings_phone_is_user_allowed_to_access_camera_settings = /** @type {(inputs: Forms_Teams_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriff auf Kameraeinstellungen erlaubt`)
};

/**
* | output |
* | --- |
* | "Camera Settings" |
*
* @param {Forms_Teams_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_phone_is_user_allowed_to_access_camera_settings = /** @type {((inputs?: Forms_Teams_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Phone_Is_User_Allowed_To_Access_Camera_SettingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_phone_is_user_allowed_to_access_camera_settings(inputs)
	return de_forms_teams_settings_phone_is_user_allowed_to_access_camera_settings(inputs)
});